<template>

  <svg
    t="1639131250073"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4137"
    width="64"
    height="64"
  ><path d="M209.77314453 868.46064453c0-20.61123047 16.70888672-37.32099609 37.32099609-37.32099609L783.19970703 831.13964844c20.61035156 0 37.32099609 16.70888672 37.3209961 37.32099609 0 20.61123047-16.70888672 37.32099609-37.3209961 37.3209961l-536.1055664 0c-20.61210937 0-37.32099609-16.70800781-37.3209961-37.3209961zM512.15292969 729.66113281c20.61123047 0 37.32099609-16.70800781 37.32099609-37.32099608l-1e-8-536.10468751c0-20.61123047-16.70800781-37.32099609-37.32099608-37.3209961-20.61123047 0-37.32099609 16.70800781-37.3209961 37.32099609l1e-8 536.10644532c0 20.61035156 16.70976562 37.31923828 37.32099609 37.31923828z m-26.48583986 27.534375c14.57402345 14.57402345 37.36845703 15.4107422 50.91240236 1.86679688l274.90429687-274.90429688c13.54394531-13.5421875 12.70810546-36.33662109-1.86679687-50.91152343-14.57402345-14.57402345-37.36845703-15.4107422-50.91152344-1.86679688l-274.9060547 274.90429688c-13.54306642 13.5421875-12.70722656 36.33662109 1.86767578 50.91152343z m52.96640626 0c14.57490234-14.57490234 15.41162109-37.36933594 1.86767579-50.91152343L265.59599609 431.37792969c-13.54394531-13.54394531-36.3375-12.70722656-50.91152343 1.86679687-14.57490234 14.57490234-15.41162109 37.36933594-1.86767579 50.91152345l274.90429688 274.90605468c13.54394531 13.54394531 36.33750001 12.70634766 50.91240235-1.86767578z" p-id="4138" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconMoveBottom',
} as DefineComponent
</script>